import { ModBusDevice } from 'z3k-config';
import { genIdAndIncCounter } from 'z3k-parser/lib/auxiliary';
import { modBusConfigs } from './modbus-configs';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
export function replaceModBusConfigIds(modBusDeviceId, modBusConfig, config) {
    let newConfig = config;
    let newId;
    let newModbusConfig = modBusConfig;
    const old2new = {};
    newModbusConfig = Object.fromEntries(Object.entries(newModbusConfig).map(([key, objects]) => {
        if (!objects)
            return [key, objects];
        return [
            key,
            objects.map((object) => {
                [newId, newConfig] =
                    genIdAndIncCounter(newConfig);
                old2new[object.id] = newId;
                return { ...object, id: newId };
            }),
        ];
    }));
    let newReplaceConfig = newModbusConfig;
    Object.entries(old2new).forEach(([oldId, newId]) => {
        newReplaceConfig = findAndChangeLinks(newModbusConfig, +oldId, newId, newReplaceConfig);
    });
    Object.entries(newReplaceConfig).forEach(([key, objects]) => {
        if (objects) {
            newConfig = {
                ...newConfig,
                [key]: [
                    ...(newConfig[key] ?? []),
                    ...objects,
                ],
            };
        }
    });
    newConfig = ModBusDevice.get.modifyById(newConfig, modBusDeviceId, (mbdev) => ({
        ...mbdev,
        signals: [
            ...mbdev.signals,
            ...(newModbusConfig.modbus_signals?.map((signal) => signal.id) ?? []),
        ],
    }));
    return newConfig;
}
export function getNewModBusConfig(currentConfig, deviceName, modBusDeviceId) {
    return replaceModBusConfigIds(modBusDeviceId, modBusConfigs[deviceName].config ?? modBusConfigs.DT130.config, currentConfig);
}
